const pages = [
    {
        //指定代理商日志查询
        name:'log.agentLog',
        path:'log/agentLog/:agent?',
        component:()=>import('../../views/Log/agentLog'),
    }
];
export default pages;